import React, { useState } from "react";
import Messages from "./Messages";
import CompanyAvatar from "../../UILibrary/CompanyAvatar";
import { useSelector } from "react-redux";

function BuyerCollaborations() {
  const [selectedTab, setSelectedTab] = useState("Messages");
  const tabs = ["Messages",
    //  "Meetings", "Profile"
    ];

  const [selectedUser, setSelectedUser] = useState(null);
  const [followers, setFollowers] = useState(0);

  const handleTabClick = (tab) => {
    setSelectedTab(tab);
  };

  const handleFollowers = () => {
    setFollowers((prev) => prev + 1);
  };
  const Meetings = () => <div>Meetings content here...</div>;
  const Profile = () => (
    <>
      <div className="flex items-center space-x-4 mb-8">
        <div>
          <CompanyAvatar
            companyName={selectedUser.contact.type[0].name.firstName}
            size="106px"
          />
        </div>

        <div className="flex flex-col justify-center text-left">
          {/* Company Name */}
          <div className="flex flex-row gap-2 justify-start items-center">
            <span className="text-[24px] font-semibold text-[#1D2739] font-hanken">
              {selectedUser.contact.type[0].name.firstName},&nbsp;
              {selectedUser.contact.type[0].name.lastName}
            </span>
            {selectedUser.diversity.certificationType.length > 0 && (
              <span className="flex items-center space-x-1 ml-4">
                <svg
                  className="w-4 h-4"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 16 16"
                  fill="none"
                >
                  <g clipPath="url(#clip0)">
                    <mask
                      id="mask0"
                      maskUnits="userSpaceOnUse"
                      x="0"
                      y="0"
                      width="16"
                      height="16"
                    >
                      <path
                        d="M8.00066 14.6663C8.87629 14.6674 9.74351 14.4955 10.5525 14.1604C11.3615 13.8253 12.0963 13.3336 12.7147 12.7137C13.3346 12.0953 13.8263 11.3605 14.1614 10.5515C14.4965 9.74254 14.6684 8.87532 14.6673 7.99968C14.6684 7.12404 14.4965 6.25682 14.1614 5.44784C13.8263 4.63886 13.3346 3.90407 12.7147 3.28568C12.0963 2.66573 11.3615 2.17409 10.5525 1.83898C9.74351 1.50388 8.87629 1.33193 8.00066 1.33301C7.12502 1.33193 6.2578 1.50388 5.44882 1.83898C4.63984 2.17409 3.90505 2.66573 3.28666 3.28568C2.66671 3.90407 2.17506 4.63886 1.83996 5.44784C1.50486 6.25682 1.33291 7.12404 1.33399 7.99968C1.33291 8.87532 1.50486 9.74254 1.83996 10.5515C2.17506 11.3605 2.66671 12.0953 3.28666 12.7137C3.90505 13.3336 4.63984 13.8253 5.44882 14.1604C6.2578 14.4955 7.12502 14.6674 8.00066 14.6663Z"
                        fill="white"
                        stroke="white"
                        strokeWidth="1.33333"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M5.33398 8L7.33398 10L11.334 6"
                        stroke="black"
                        strokeWidth="1.33333"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </mask>
                    <g mask="url(#mask0)">
                      <rect width="16" height="16" fill="#0088FF" />
                    </g>
                  </g>
                  <defs>
                    <clipPath id="clip0">
                      <rect width="16" height="16" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
                <p className="text-blue-500 text-sm">Certified</p>
              </span>
            )}
          </div>

          {/* salutation */}
          <span className="text-[16px] text-[#9A9A9A] font-hanken font-normal">
            {selectedUser.contact.type[0].Salutation}
          </span>

          <span className="text-[20px] text-[#0088FF] font-hanken font-normal">
            {selectedUser.company.name}
          </span>

          {/* Location + Rating + Certification */}
          <div className="flex flex-row gap-4 text-[#1D2739] font-hanken text-[16px]">
            <div className="flex flex-row  justify-start items-center">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
              >
                <path
                  d="M12 20.3249C11.7667 20.3249 11.5292 20.2832 11.2875 20.1999C11.0458 20.1166 10.8333 19.9832 10.65 19.7999L8.925 18.2249C7.15833 16.6082 5.5625 15.0041 4.1375 13.4124C2.7125 11.8207 2 10.0666 2 8.1499C2 6.58324 2.525 5.2749 3.575 4.2249C4.625 3.1749 5.93333 2.6499 7.5 2.6499C8.38333 2.6499 9.21667 2.8374 10 3.2124C10.7833 3.5874 11.45 4.0999 12 4.7499C12.55 4.0999 13.2167 3.5874 14 3.2124C14.7833 2.8374 15.6167 2.6499 16.5 2.6499C18.0667 2.6499 19.375 3.1749 20.425 4.2249C21.475 5.2749 22 6.58324 22 8.1499C22 10.0666 21.2917 11.8249 19.875 13.4249C18.4583 15.0249 16.85 16.6332 15.05 18.2499L13.35 19.7999C13.1667 19.9832 12.9542 20.1166 12.7125 20.1999C12.4708 20.2832 12.2333 20.3249 12 20.3249ZM11.05 6.7499C10.5667 6.06657 10.05 5.54574 9.5 5.1874C8.95 4.82907 8.28333 4.6499 7.5 4.6499C6.5 4.6499 5.66667 4.98324 5 5.6499C4.33333 6.31657 4 7.1499 4 8.1499C4 9.01657 4.30833 9.9374 4.925 10.9124C5.54167 11.8874 6.27917 12.8332 7.1375 13.7499C7.99583 14.6666 8.87917 15.5249 9.7875 16.3249C10.6958 17.1249 11.4333 17.7832 12 18.2999C12.5667 17.7832 13.3042 17.1249 14.2125 16.3249C15.1208 15.5249 16.0042 14.6666 16.8625 13.7499C17.7208 12.8332 18.4583 11.8874 19.075 10.9124C19.6917 9.9374 20 9.01657 20 8.1499C20 7.1499 19.6667 6.31657 19 5.6499C18.3333 4.98324 17.5 4.6499 16.5 4.6499C15.7167 4.6499 15.05 4.82907 14.5 5.1874C13.95 5.54574 13.4333 6.06657 12.95 6.7499C12.8333 6.91657 12.6917 7.04157 12.525 7.1249C12.3583 7.20824 12.1833 7.2499 12 7.2499C11.8167 7.2499 11.6417 7.20824 11.475 7.1249C11.3083 7.04157 11.1667 6.91657 11.05 6.7499Z"
                  fill="#1D2739"
                />
              </svg>
              <span className="ml-1">{followers} Followers</span>
            </div>
            <div
              onClick={handleFollowers}
              className="flex flex-row justify-start items-center cursor-pointer"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
              >
                <path
                  d="M11 13H6C5.71667 13 5.47917 12.9042 5.2875 12.7125C5.09583 12.5208 5 12.2833 5 12C5 11.7167 5.09583 11.4792 5.2875 11.2875C5.47917 11.0958 5.71667 11 6 11H11V6C11 5.71667 11.0958 5.47917 11.2875 5.2875C11.4792 5.09583 11.7167 5 12 5C12.2833 5 12.5208 5.09583 12.7125 5.2875C12.9042 5.47917 13 5.71667 13 6V11H18C18.2833 11 18.5208 11.0958 18.7125 11.2875C18.9042 11.4792 19 11.7167 19 12C19 12.2833 18.9042 12.5208 18.7125 12.7125C18.5208 12.9042 18.2833 13 18 13H13V18C13 18.2833 12.9042 18.5208 12.7125 18.7125C12.5208 18.9042 12.2833 19 12 19C11.7167 19 11.4792 18.9042 11.2875 18.7125C11.0958 18.5208 11 18.2833 11 18V13Z"
                  fill="#0088FF"
                />
              </svg>
              <span className="ml-1">Follow</span>
            </div>
          </div>
        </div>
      </div>

      <div>
        <span className="flex justify-start items-start font-semibold text-sm mb-2">
          Personal Description
        </span>
        <p
          className="text-[#7B7B7B] text-left font-lato text-sm font-normal leading-[20px] p-4 rounded-xl"
          style={{ border: "1.081px solid #EBEBEB" }}
        >
          {selectedUser.company.description || selectedUser.capability.capabilityDetails[0].description}
        </p>
      </div>

      <div>
        <span className="flex justify-start items-start font-semibold text-sm mb-2 mt-8">
          Contact Information
        </span>
        <div
          className="text-[#7E7E7E] text-left font-lato text-sm font-normal leading-[20px] p-4 rounded-xl"
          style={{ border: "1.081px solid #EBEBEB" }}
        >
          <div className="grid grid-cols-2 gap-4">
            <div className="flex items-center">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                className="mr-2"
              >
                <path
                  d="M19.95 21C17.8667 21 15.8083 20.5458 13.775 19.6375C11.7417 18.7292 9.89167 17.4417 8.225 15.775C6.55833 14.1083 5.27083 12.2583 4.3625 10.225C3.45417 8.19167 3 6.13333 3 4.05C3 3.75 3.1 3.5 3.3 3.3C3.5 3.1 3.75 3 4.05 3H8.1C8.33333 3 8.54167 3.07917 8.725 3.2375C8.90833 3.39583 9.01667 3.58333 9.05 3.8L9.7 7.3C9.73333 7.56667 9.725 7.79167 9.675 7.975C9.625 8.15833 9.53333 8.31667 9.4 8.45L6.975 10.9C7.30833 11.5167 7.70417 12.1125 8.1625 12.6875C8.62083 13.2625 9.125 13.8167 9.675 14.35C10.1917 14.8667 10.7333 15.3458 11.3 15.7875C11.8667 16.2292 12.4667 16.6333 13.1 17L15.45 14.65C15.6 14.5 15.7958 14.3875 16.0375 14.3125C16.2792 14.2375 16.5167 14.2167 16.75 14.25L20.2 14.95C20.4333 15.0167 20.625 15.1375 20.775 15.3125C20.925 15.4875 21 15.6833 21 15.9V19.95C21 20.25 20.9 20.5 20.7 20.7C20.5 20.9 20.25 21 19.95 21Z"
                  fill="#7E7E7E"
                />
              </svg>
              <p>Phone number</p>
            </div>
            <div className="flex items-center">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                className="mr-2"
              >
                <path
                  d="M4 20C3.45 20 2.97917 19.8042 2.5875 19.4125C2.19583 19.0208 2 18.55 2 18V6C2 5.45 2.19583 4.97917 2.5875 4.5875C2.97917 4.19583 3.45 4 4 4H20C20.55 4 21.0208 4.19583 21.4125 4.5875C21.8042 4.97917 22 5.45 22 6V18C22 18.55 21.8042 19.0208 21.4125 19.4125C21.0208 19.8042 20.55 20 20 20H4ZM20 8L12.525 12.675C12.4417 12.725 12.3542 12.7625 12.2625 12.7875C12.1708 12.8125 12.0833 12.825 12 12.825C11.9167 12.825 11.8292 12.8125 11.7375 12.7875C11.6458 12.7625 11.5583 12.725 11.475 12.675L4 8V18H20V8ZM12 11L20 6H4L12 11Z"
                  fill="#7E7E7E"
                />
              </svg>
              <p>Email</p>
            </div>

            <div className="col-span-2 border-t border-[#EBEBEB]" />

            <div>{selectedUser?.contact?.type[0]?.phoneNumber || "—"}</div>
            <div>{selectedUser?.contact?.type[0]?.email || "—"}</div>
          </div>
        </div>
      </div>

      <div>
        <span className="flex justify-start items-start font-semibold text-sm mb-2 mt-8">
          Reviews
        </span>
        <div
          className="text-[#7E7E7E] text-left font-lato text-sm font-normal leading-[20px] p-4 rounded-xl"
          style={{ border: "1.081px solid #EBEBEB" }}
        >
          No reviews yet
          </div>
          </div>
    </>
  );

  const renderTabContent = () => {
    switch (selectedTab) {
      case "Messages":
        return (
          <Messages
            selectedUser={selectedUser}
            setSelectedUser={setSelectedUser}
          />
        );
      // case "Meetings":
      //   return <Meetings />;
      // case "Profile":
      //   return selectedUser !== null ? <Profile /> : null;
      default:
        return null;
    }
  };

  return (
    <div className="mt-10 ml-10 mr-10">
      <span className="text-[#1D2739] font-medium text-[24px] leading-normal font-hanken flex justify-start text-left">
        Collaborations
      </span>

      <div className="flex gap-4 mt-4">
        {tabs.map((tab) => (
          <button
            key={tab}
            onClick={() => handleTabClick(tab)}
            disabled={tab === "Meetings"}
            className={`px-4 py-2 rounded transition duration-200 ${
              tab === "Meetings"
                ? "text-gray-400 cursor-not-allowed"
                : selectedTab === tab
                ? "text-black rounded-[1px] border-b-2 border-[#08F]"
                : "text-[#7B7B7B] hover:text-black"
            }`}
          >
            {tab}
          </button>
        ))}
      </div>

      <div className="mt-6">{renderTabContent()}</div>
    </div>
  );
}

export default BuyerCollaborations;
